import { createSlice } from "@reduxjs/toolkit";
import { fetchOngoingOrdersReducer } from "../../reducer/dashboard/fetchOngoingOrdersReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  isLoading: false,
  error: null,
};

const ongoingOrdersSlice = createSlice({
  name: "ongoingOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOngoingOrdersReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOngoingOrdersReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.orders || [];
        state.pagination = {
          page: action.payload?.pagination?.page || 1,
          limit: action.payload?.pagination?.limit || 10,
          total: action.payload?.pagination?.total || 0,
          totalPages:
            action.payload?.pagination?.totalPages ||
            action.payload?.pagination?.total_pages ||
            1,
        };
      })
      .addCase(fetchOngoingOrdersReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadOngoingOrders");
      });
  },
});

export default ongoingOrdersSlice.reducer;
